import React from "react";
import SFCheckbox from "../../checkbox";
import SFTypography from "../../typography";
import getStyled from "../../../hooks/getStyled";
import { SFStack } from "../../grid";
import PropTypes from "prop-types";

const { styled } = getStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const TuneFilter = ({ tuneFilter }) => {
  return (
    <StyledStack alignItems={"flex-start"}>
      {tuneFilter.map((checkbox) => (
        <SFCheckbox
          key={checkbox?.name}
          checked={checkbox?.checked}
          onChange={checkbox?.onChange}
          size="medium"
          label={<SFTypography variant="body1">{checkbox?.label}</SFTypography>}
        />
      ))}
    </StyledStack>
  );
};

export default TuneFilter;

/**
 * PropTypes definition for the TuneFilter component.
 * This component displays a list of checkboxes for tuning search options.
 */
TuneFilter.propTypes = {
  /**
   * Array of tune filter options to display as checkboxes.
   * Each filter option has its own onChange handler to manage its state.
   */
  tuneFilter: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unique identifier for the checkbox.
       */
      name: PropTypes.string.isRequired,

      /**
       * Whether the checkbox is checked.
       */
      checked: PropTypes.bool.isRequired,

      /**
       * Handler function called when the checkbox state changes.
       * @param {object} event - The change event from the checkbox.
       */
      onChange: PropTypes.func.isRequired,

      /**
       * Display text for the checkbox.
       */
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};
